import { Eligibility } from '@general/js/enums/EligibilityEnum';

/**
 * Map the eligibility type to the label needed for service connection form input
 *
 * @param {String} eligibility - eligibility type
 * @returns {string} - The linked label required for form
 */
export const getServiceConnectionLabel = (eligibility) => {
  if (eligibility != null) {
    switch (eligibility) {
      case Eligibility.SERVING:
        return 'Who is currently serving?';
      case Eligibility.EX_SERVING:
        return 'Who served?';
      case Eligibility.WORK_CONNECTION:
        return 'Who had/has a work connection to the Defence or a Defence–related government department?';
      case Eligibility.RELATED:
        return 'Who is related to the person who serves/served?';
      default:
        logger.log('Invalid Eligibility');
    }
  }
  return null;
};

/**
 * Map the eligibility type to the label needed for declaration form input
 *
 * @param {String} connection - eligibility type
 * @returns {string} - The linked label required for form
 */
export const getDeclarationLabel = (eligibility) => {
  if (eligibility != null) {
    switch (eligibility) {
      case Eligibility.SERVING:
      case 'ADF':
      case Eligibility.EX_SERVING:
      case 'ExServing':
        return 'I declare the details I have provided are true and correct.';
      case Eligibility.DPS:
        return 'I declare the details I have provided are true and current.';
      case Eligibility.CONTRACTOR:
        return 'I declare the details I have provided are true and correct. I further declare that the person with the work connection is/was involved in supplying goods or services to Defence.';
      default:
        return '';
    }
  }
  return null;
};

/**
 * Map the eligibility type to the label needed for service agency form input
 *
 * @param {String} eligibility - eligibility type
 * @param {boolean} relatives - True if the eligibility is for supporting relatives.
 * @returns {string} - The linked label required for form
 */
export const getServiceAgencyLabel = (eligibility, relatives) => {
  if (eligibility != null) {
    switch (eligibility) {
      case Eligibility.SERVING:
        if (relatives) {
          return 'They serve in';
        }
        return 'I/my partner serve in the';
      case Eligibility.EX_SERVING:
        if (relatives) {
          return 'They served in';
        }
        return 'I/my partner served in the';
      default:
        return '';
    }
  }
  return null;
};

/**
 * Map the eligibility type to the label needed for service period form input
 *
 * @param {String} eligibility - eligibility type
 * @param {boolean} relatives - True if the string is for supporting relatives.
 * @returns {string} - The linked label required for form
 */
export const getServicePeriodLabel = (eligibility, relatives) => {
  if (eligibility != null) {
    switch (eligibility) {
      case Eligibility.SERVING:
        if (relatives) {
          return 'Their service is';
        }
        return 'My/My Partner’s service is';
      case Eligibility.EX_SERVING:
        if (relatives) {
          return 'Their service was';
        }
        return 'My/My Partner’s service was';
      default:
        return '';
    }
  }
  return null;
};

/**
 * Map the work connection type to the label needed for connection name form input
 *
 * @param {String} connection - eligibility type
 * @returns {string} - The linked label required for form
 */
export const getEligibilityWorkLabel = (connection) => {
  if (connection != null) {
    switch (connection) {
      case Eligibility.CONTRACTOR:
        return 'Company name';
      case Eligibility.DPS:
        return 'Department name';
      default:
        return '';
    }
  }
  return null;
};

/**
 * Map the work connection type to the label needed for connection name placeholder
 *
 * @param {String} connection - eligibility type
 * @returns {string} - The linked label required for form
 */
export const getEligibilityWorkPlaceHolder = (connection) => {
  if (connection != null) {
    switch (connection) {
      case Eligibility.CONTRACTOR:
        return 'Enter company name';
      case Eligibility.DPS:
        return 'Enter department name';
      default:
        return '';
    }
  }
  return null;
};

/**
 * Map the eligibility type to the eligibility enum used in JoinNow
 *
 * @param {String} eligibility - eligibility type
 * @returns {string} - Enum of the mapped value
 */
export const getEligibility = (eligibility) => {
  if (eligibility != null) {
    switch (eligibility) {
      case 'ADF':
        return Eligibility.SERVING;
      case 'ExServing':
        return Eligibility.EX_SERVING;
      case 'Supporting':
        return Eligibility.RELATED;
      case 'WorkConnection':
        return Eligibility.WORK_CONNECTION;
      default:
        return '';
    }
  }
  return null;
};

export const EMIT_KEYS = {
  FORM_UPDATED: 'formUpdated',
  BACK_BUTTON_PRESSED: 'backButtonPressed',
  ABD_LHC_UPDATED: 'abdLhcUpdated',
  LHC_ELIGIBILITY_UPDATED: 'updateEligibleForLHC',
  CURRENT_MEMBER_UPDATED: 'currentMemberUpdated',
};

export const isInvalid = (value) => {
  return !value;
};
